import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const deviations = {
  firestorePath: '/deviations',
  firestoreRefType: 'collection',
  moduleName: 'deviations',
  statePropName: 'deviations',
  namespaced: true,
  sync: {
    debounceTimerMs: 1
  },

  state, getters, actions, mutations
}

export default deviations